jQuery(function() {
	var footer = $('.footer').innerHeight();
	
	window.onscroll = function () {
	  var point = window.pageYOffset;
	  var docHeight = $(document).height();
	  var dispHeight = $(window).height();
	
	  if(point > docHeight-dispHeight-footer){
		$('.header').addClass('is-hidden');
	  }else{
		$('.header').removeClass('is-hidden');
	  }
	};
});